import { render, staticRenderFns } from "./recipe-detail-page.vue?vue&type=template&id=1009b4e4&scoped=true"
import script from "./recipe-detail-page.vue?vue&type=script&lang=js"
export * from "./recipe-detail-page.vue?vue&type=script&lang=js"
import style0 from "./recipe-detail-page.vue?vue&type=style&index=0&id=1009b4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009b4e4",
  null
  
)

export default component.exports